import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography
} from 'web-library';

interface LateApplicationDialogProps {
  open: boolean;
  onProceed?: () => void;
  onCancel: () => void;
}

const LateApplicationDialog = ({ open, onProceed, onCancel }: LateApplicationDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} maxWidth="sm">
      <DialogTitle>{t('accessArrangement->>Notes.LateAppModalHeader')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{t('accessArrangement->>Notes.LateAppModalDesc')}</Typography>
      </DialogContent>
      <DialogActions>
        <Grid container justify="flex-end" wrap="nowrap" direction="row">
          <Button variant="text" onClick={onCancel}>
            {t('ccessArrangement->>Notes.Cancel')}
          </Button>
          <Button variant="contained" onClick={onProceed}>
            {t('ccessArrangement->>Notes.Proceed')}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
);
};

export default LateApplicationDialog;
